import React from "react";
import {
  TextField,
  Typography,
  Box,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { useFormikContext } from "formik";
import { fieldConfig } from "../config/fieldConfig";

const BasicInfoSection = () => {
  const { values, handleChange, touched, errors } = useFormikContext();

  const fields = [
    "tour_name",
    "description",
    "country",
    "state",
    "city",
    "duration",
  ];

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="h6" gutterBottom>
        Basic Info
      </Typography>

      <Typography variant="body2" color="textSecondary" gutterBottom>
        Please provide the basic details of your tour below. This information
        helps travelers understand what your tour offers.
      </Typography>

      {Object.entries(fieldConfig.basicInfo).map(([field, config]) => (
        <TextField
          key={field}
          fullWidth
          label={config.label}
          placeholder={config.placeholder}
          name={`basicInfo.${field}`}
          value={values.basicInfo[field]}
          onChange={handleChange}
          error={
            touched.basicInfo?.[field] && Boolean(errors.basicInfo?.[field])
          }
          helperText={
            touched.basicInfo?.[field]
              ? errors.basicInfo?.[field]
              : config.helperText
          }
        />
      ))}

      <FormControl
        fullWidth
        error={
          touched.basicInfo?.tour_type && Boolean(errors.basicInfo?.tour_type)
        }
      >
        <InputLabel>Tour Type</InputLabel>
        <Select
          name="basicInfo.tour_type"
          value={values.basicInfo.tour_type}
          onChange={handleChange}
        >
          <MenuItem value="adventure">Adventure</MenuItem>
          <MenuItem value="leisure">Leisure</MenuItem>
          <MenuItem value="cultural">Cultural</MenuItem>
          <MenuItem value="wildlife">Wildlife</MenuItem>
        </Select>

        <FormHelperText>
          {touched.basicInfo?.tour_type && errors.basicInfo?.tour_type
            ? errors.basicInfo.tour_type
            : "Select the main theme of your tour"}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default BasicInfoSection;
